import { ReportDefinition, SelectionDefinition, FavouriteDefinition } from 'app/types-shared';
import { SelectionFieldItem, SelectionType } from './types-fields';
import { adjustToFiltersOptionValue } from 'app/area/reports/constants';
import { updateSelectedReport } from '../../selected-report';
import { storeValueToCodeItem } from 'app/infrastructure/data/codes';

export const mapToSelectionDefinition = (item: SelectionFieldItem, id: number): SelectionDefinition => {
  const selection: SelectionDefinition = {
    id,
    domain: storeValueToCodeItem(item.field),
    type: {
      v: item.value.type
    },
    fillEmpty: !!item.value.fillEmpty ? 1 : 0,
    period: { v: 0 },
    setLevelAccToCond: false
  };

  if (item.value.sortOrderType) {
    selection.sortOrderType = { v: item.value.sortOrderType.value };
  }

  if (item.value.type === SelectionType.Interval) {
    selection.interval = item.value.interval;
  }

  if (item.value.type === SelectionType.Period && item.value.period) {
    selection.period = { v: item.value.period.value };
  }

  if (item.value.type === SelectionType.AggregateValue && item.value.level) {
    if (item.value.level.value === adjustToFiltersOptionValue) {
      selection.setLevelAccToCond = true;
      const aggregateValueSelection = !!item.selectionTypes && item.selectionTypes
        .find(s => s.type === SelectionType.AggregateValue && !!s.levels && s.levels.length > 1);
      if (!!aggregateValueSelection) {
        selection.levels = aggregateValueSelection.levels[1].value as number;
      }
    } else {
      selection.levels = item.value.level.value as number;
    }
  }

  if (item.value.type === SelectionType.AggregateCategory) {
    if (item.value.level.value === adjustToFiltersOptionValue) {
      selection.setLevelAccToCond = true;
      const aggregateCategorySelection = !!item.selectionTypes && item.selectionTypes
        .find(s => s.type === SelectionType.AggregateCategory && !!s.levels && s.levels.length > 1);
      if (!!aggregateCategorySelection) {
        selection.levels = aggregateCategorySelection.levels[1].value as number;
      }
    } else {
      selection.levels = item.value.level.value as number;
    }
    selection.selectedCode = !!item.value.category
      ? item.value.category.value as number
      : undefined;
  }

  return selection;
};

const getRollingAverage = (selectedGroupByFields: SelectionFieldItem[]) => {
  if (!!selectedGroupByFields
    && selectedGroupByFields.length > 0
  ) {
    const firstSelection = selectedGroupByFields[0];
    if (firstSelection.value && firstSelection.value.type === SelectionType.Period) {
      return firstSelection.value.rollingAverage;
    }
  }
  return undefined;
};

const updateReport = (report: ReportDefinition, updatedFields: Partial<ReportDefinition>) => {
  return {
    ...report,
    ...updatedFields
  };
};

export const updateGroupBy = (
  definition: FavouriteDefinition, selectedGroupByFields: SelectionFieldItem[]
) => {
  const report = definition.reports.find(r => r.report.v === definition.selectedReport.v);
  let returnedReport: ReportDefinition = {
    ...report
  };

  if (!!selectedGroupByFields) {
    returnedReport = updateReport(returnedReport, {
      selections: selectedGroupByFields
        .filter(s => s.value && s.value.type)
        .map((s, id) => ({
          ...mapToSelectionDefinition(s, id + 1)
        }))
    });
  }

  const rollingAverage = getRollingAverage(selectedGroupByFields);
  if (!!rollingAverage) {
    returnedReport = updateReport(returnedReport, { rollingAverage });
  } else {
    returnedReport = {
      ...returnedReport,
      rollingAverage: 0
    };
  }
  return updateSelectedReport(definition, returnedReport);
};
